import {Button, RingProgress, Skeleton, Stack, Text, Tooltip} from "@mantine/core"
import { homeHooks } from "features/homes/hooks"
import {IHome, IHomeSellScore} from "features/homes/types"
import { IStrapiEntity } from "services/strapi"

interface Props {
    sellScore?: IHomeSellScore
    home?: IStrapiEntity<IHome>
    loading?: boolean
}

export function HomeSellScore({sellScore, home, loading}: Props) {
    const {mutateAsync: getFullReport, isLoading: isLoadingFullReport} = homeHooks.useGetFullReport()

    function renderSellScore() {
        if (loading) {
            return <Skeleton height={72}/>
        } else if (!sellScore || sellScore.voidedOn) {
            return (
                <Text size={24} weight={500} style={{textAlign: "center"}}>
                    Your home's sell score is currently being generated, please check back
                    later.
                </Text>
            )
        } else {
            let color = "green"
            if (sellScore.score){
                if (sellScore.score < 40) {
                    color = "red"
                } else if (sellScore.score < 70) {
                    color = "orange"
                }
            }
            return (
                <RingProgress
                    roundCaps
                    thickness={8}
                    sections={[{value: sellScore.score || 0, color: color}]}
                    label={
                        <Text color={color} weight={700} align="center" size="xl">
                            {sellScore.score || 0}%
                        </Text>
                    }
                />
                // <Text size={48} weight={700} color="green">
                //   {sellScore.score}
                // </Text>
            )
        }
    }

    return (
        <Stack spacing="xs" align="center">
            <Text weight={600} size="lg">
                Sell Score
            </Text>
            {renderSellScore()}
            <Tooltip label="Coming soon!" withArrow>
                <div>
                    <Button loading={isLoadingFullReport} onClick={() => getFullReport(home?.id)} disabled={true}>
                        Full Report
                    </Button>
                </div>
            </Tooltip>
        </Stack>
    )
}
